const isProductionBuild = process.env.VUE_APP_ENVAPP === 'production'

export default isProductionBuild ? [] : [
  {
    path: '/recap/preview/:scenario?',
    name: 'YearRecapPreview',
    meta: { title: 'Year recap preview' },
    component: () => import('./YearRecapPreview.vue'),
  },
]
